// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2hWpo","rootCenter":"LoadMoreObserver_rootCenter__eK891","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2vv2C"};